(function($) {

	$.fn.numberInput = function() {
		var elem = $(this),
		    targets = elem.find('.quantity'),
		    triggers = elem.find('.js-search__trigger'),
		    settings = {
			    activeClass: 'is-active',
			    visibleClass: 'is-active',
			    elemClass: 'search-box--active',
			    elemClassAttribute: 'data-elem-class'
		    };

		    var init = function() {

                $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.quantity input');
                
                $('.quantity').each(function() {
                    var spinner = jQuery(this),
                          input = spinner.find('input[type="number"]'),
                          btnUp = spinner.find('.quantity-up'),
                        btnDown = spinner.find('.quantity-down');

                    btnUp.click(function() {
                        var oldValue = parseFloat(input.val());

                        if (oldValue >= 1) {
                            var newVal = oldValue + 1;
                        }

                        spinner.find("input").val(newVal);
                        spinner.find("input").trigger("change");
                        
                    });

                    btnDown.click(function() {
                        var oldValue = parseFloat(input.val());

                        if (oldValue <= 1) {
                            var newVal = oldValue;
                        } else {
                            var newVal = oldValue - 1;
                        }
                        
                        spinner.find("input").val(newVal);
                        spinner.find("input").trigger("change");
                    });

                });
			    
		    };

		init();
		return this;
	};

}(jQuery));